module.exports = __webpack_public_path__ + "img/e0a4c8b.jpg";